module.exports = __webpack_public_path__ + "img/porcientoDescuento.11846041.jpg";